import Vuex from './vuex';
import App from './App.vue';
import {createApp} from 'vue';
import pt from './locales/pt.json';
import router from './router/router';
import {createI18n} from 'vue-i18n';
import VueTheMask from 'vue-the-mask';
import Toast from 'vue-toastification';
import VueGtag from 'vue-gtag-next';
import GAuth from 'vue3-google-oauth2';
import 'vue-toastification/dist/index.css';
import VueApexCharts from 'vue3-apexcharts';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import widthMd from "@/Helpers/global/WidthMd";
import permissionInstance from "@/Helpers/global/Permission";
import axios from 'axios';
import VueAxios from 'vue-axios';
import './registerServiceWorker';
import ErrorComponent from './components/layouts/errorComponent.vue';
import {httpCustom} from './services/config';
import stores from './vuex';

const messages = {
    pt,
}

const i18n = new createI18n({
    legacy: false,
    locale: process.env.VUE_APP_I18N_LOCALE || 'pt',
    fallbackLocale: process.env.VUE_APP_I18N_LOCALE || 'pt',
    messages,
    missingWarn: false,
    fallbackWarn: false,
})

const app = createApp(App)

app.mixin(ErrorComponent);

if (process.env.NODE_ENV === 'production') app.use(GAuth, {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    scope: 'profile',
    prompt: 'consent',
    fetch_basic_profile: true,
});

app.use(i18n)
app.use(Vuex)
app.use(router)
app.use(VueTheMask)
app.use(VueApexCharts)
app.use(VueSweetalert2)
app.use(VueAxios, axios)
app.use(Toast, {position: 'top-right'})
app.use(VueGtag, {
    property: {
        id: "UA-37317143-1",
        params: {
            user_id: "12345",
            send_page_view: true,
            globalObjectName:"R2 Soft",
            app_name: "R2 Disponibilidade",
            linker: {
                domain: [`${process.env.VUE_APP_BASE_URL}`]
            }
        }
    }
})
app.config.globalProperties.$widthMd = widthMd;
app.config.globalProperties.$hasPermission = function(permission, custom = false) {
    return permissionInstance.validatePermissions(permission, custom);
};
app.config.globalProperties.$setCustomToken = async function (token, refreshToken){
    sessionStorage.setItem('access_token_custom', token);
    sessionStorage.setItem('refresh_token_custom', refreshToken)
    httpCustom.defaults.headers.authorization = `Bearer ${token}`;
    httpCustom.defaults.headers.common['company-id'] = localStorage.getItem('companyId');
    await stores.dispatch('actionTimeoutRefreshTokenCustom');
};
app.config.globalProperties.$canAccess = function(permission) {
    if (!permissionInstance.validatePermissions(permission)) {
        document.getElementById('closeX')?.click();
        router.push({name:'Home'});
    }
};
app.mount('#app')
